import ApprovalWrapper from "./ApprovalWrapper";

export default ApprovalWrapper;



// WEBPACK FOOTER //
// ./src/components/WorkFlow/ApprovalWrapper/index.js